"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    ref: "modal-ref",
    class: "modal fade",
    "aria-hidden": "true",
    "data-backdrop": "static"
};
const _hoisted_2 = { class: "modal-dialog modal-lg position-center" };
const _hoisted_3 = { class: "modal-content" };
const _hoisted_4 = { class: "modal-header" };
const _hoisted_5 = { class: "modal-title" };
const _hoisted_6 = { class: "modal-body" };
const _hoisted_7 = { class: "modal-footer" };
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BssModal',
    props: /*@__PURE__*/ (0, vue_1.mergeModels)({
        title: {}
    }, {
        "modelValue": { type: Boolean },
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const active = (0, vue_1.useModel)(__props, "modelValue");
        const elm = (0, vue_3.useTemplateRef)('modal-ref');
        (0, vue_3.onMounted)(() => {
            (0, vue_3.watch)(active, () => {
                if (!elm.value)
                    return;
                if (active.value) {
                    window._modal.show(elm.value);
                }
                else {
                    window._modal.hide(elm.value);
                }
            }, { immediate: true });
        });
        function openDialog() {
            return __awaiter(this, void 0, void 0, function* () {
                active.value = true;
            });
        }
        function closeDialog() {
            return __awaiter(this, void 0, void 0, function* () {
                active.value = false;
            });
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", {
                    onClick: (0, vue_2.withModifiers)(openDialog, ["stop"]),
                    style: { "display": "contents" }
                }, [
                    (0, vue_2.renderSlot)(_ctx.$slots, "trigger")
                ]),
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                    (0, vue_2.renderSlot)(_ctx.$slots, "header", {}, () => [
                                        (0, vue_2.createElementVNode)("h4", _hoisted_5, (0, vue_2.toDisplayString)(props.title), 1),
                                        (0, vue_2.createElementVNode)("button", {
                                            class: "close",
                                            onClick: (0, vue_2.withModifiers)(closeDialog, ["stop"])
                                        })
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                    (0, vue_2.renderSlot)(_ctx.$slots, "default")
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                    (0, vue_2.renderSlot)(_ctx.$slots, "footer", { close: closeDialog }, () => [
                                        (0, vue_2.createElementVNode)("button", {
                                            class: "btn btn-default",
                                            onClick: (0, vue_2.withModifiers)(closeDialog, ["stop"])
                                        }, "閉じる")
                                    ])
                                ])
                            ])
                        ])
                    ], 512)
                ]))
            ], 64));
        };
    }
});
